import React, { Component, Suspense, lazy } from "react";
export class PageLoadBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return (
      <div role="alert" className="min-h-screen flex flex-col items-center justify-center gap-3 bg-background text-foreground p-6 text-center">
        <h1 className="text-lg font-semibold">Modul konnte nicht geöffnet werden</h1>
        <p className="text-sm text-muted-foreground">Bitte prüfen Sie Ihre Verbindung und laden Sie die Seite neu.</p>
        <button type="button" onClick={() => window.location.reload()} className="px-4 py-2 rounded-sm border border-border hover:bg-accent">Seite neu laden</button>
      </div>
    );
    return this.props.children;
  }
}
export function loadPage(loader) {
  const Page = lazy(loader);
  return function DeferredPage(props) {
    return (
      <PageLoadBoundary>
        <Suspense fallback={<div role="status" className="min-h-screen flex items-center justify-center bg-background text-muted-foreground text-sm">Modul wird geladen …</div>}>
          <Page {...props} />
        </Suspense>
      </PageLoadBoundary>
    );
  };
}
